import addResults from '../actions/addResults';
import selectInlineSearchAction from '../actions/selectInlineSearchAction';
import datapoints, { logCortanaUsage } from '../datapoints';
import executeDoradoRuntime from '../service/executeDoradoRuntime';
import store from '../store/cortanaComposeStore';
import DoradoSearchResult from '../store/schema/DoradoSearchResult';
import getActionParametersForAction from '../utils/getActionParametersForAction';
import { trace } from 'owa-trace';
import { orchestrator } from 'satcheljs';
import {
    openFlexPaneForAction,
    openFlexPaneWithResults,
} from '../components/CortanaComposeFlexPane';
import CortanaComposeResult, {
    CortanaComposeResultType,
    CortanaComposeResultSection,
} from '../store/schema/CortanaComposeResult';

export { CortanaComposeResult };
export default orchestrator(selectInlineSearchAction, async actionMessage => {
    if (
        actionMessage.result &&
        actionMessage.result.type === CortanaComposeResultType.doradoResult
    ) {
        handleDoradoResultSelected(actionMessage.result);
    }
});

async function handleDoradoResultSelected(result: CortanaComposeResult) {
    const doradoRuntimeResult = result.resultObject as DoradoSearchResult;
    const actionParameters = getActionParametersForAction(
        doradoRuntimeResult.doradoAction,
        doradoRuntimeResult.doradoEntities
    );

    logCortanaUsage(
        datapoints.CortanaComposeSearchOptionSelected.datapoint.name,
        datapoints.CortanaComposeSearchOptionSelected.datapoint.customData(
            store.currentSearchCorrelationId
        )
    );

    const requiresUserInput =
        actionParameters.filter(actionParameter => actionParameter.requiresUserInput).length > 0;
    if (requiresUserInput) {
        trace.info('[CortanaCompose] Bound entity has search action');
        logCortanaUsage(
            datapoints.CortanaComposeFlexPaneOpened.datapoint.name,
            datapoints.CortanaComposeFlexPaneOpened.datapoint.customData(
                store.currentSearchCorrelationId,
                true /*requiresUserInput*/
            )
        );
        openFlexPaneForAction(true, doradoRuntimeResult.doradoAction, actionParameters);
    } else {
        trace.info('[CortanaCompose] Bound entity has no search action');
        addResults(CortanaComposeResultSection.dorado, [
            {
                onSelected: null,
                selectable: false,
                type: CortanaComposeResultType.loading,
            },
        ]);

        const runtimeResult = await executeDoradoRuntime(
            doradoRuntimeResult.doradoAction,
            actionParameters,
            store.currentSearchCorrelationId
        );
        if (runtimeResult) {
            logCortanaUsage(
                datapoints.CortanaComposeFlexPaneOpened.datapoint.name,
                datapoints.CortanaComposeFlexPaneOpened.datapoint.customData(
                    store.currentSearchCorrelationId,
                    false /*requiresUserInput*/
                )
            );
            openFlexPaneWithResults(doradoRuntimeResult.doradoAction, runtimeResult);
        } else {
            trace.info('[CortanaComposeDataProvider] DoradoRuntime returned no result');
        }
    }
}
